<template>
  <el-dialog
    title="变更渠道"
    :visible.sync="dialogVisible"
    width="500px"
    :before-close="handleClose"
  >
    <el-form
      :model="form"
      :rules="rules"
      ref="channelForm"
      label-width="100px"
    >
      <el-form-item label="渠道" prop="channel">
        <el-autocomplete
          v-model="form.channel"
          :fetch-suggestions="queryChannel"
          placeholder="请输入关键字搜索"
          style="width: 100%"
          clearable
          @select="handleSelectChannel"
        >
          <template slot-scope="{ item }">
            <div>{{ item.realname }} {{ item.alias ? '(' + item.alias + ')' : '' }}</div>
          </template>
        </el-autocomplete>
      </el-form-item>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="handleSubmit" :loading="submitLoading"
        >保 存</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import { getChannelList, updateZcbUser } from '@/api/member'

export default {
  name: 'ChangeChannel',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    userId: {
      type: [String, Number],
      default: ''
    },
    appId: {
      type: [String, Number],
      default: ''
    }
  },
  data() {
    return {
      dialogVisible: this.visible,
      submitLoading: false,
      channelList: [],
      selectedChannelId: '',
      form: {
        channel: ''
      },
      rules: {
        channel: [
          { required: true, message: '请选择渠道', trigger: 'blur' }
        ]
      }
    }
  },
  watch: {
    visible(newVal) {
      this.dialogVisible = newVal
      if (newVal) {
        this.form.channel = ''
        this.selectedChannelId = ''
      }
    }
  },
  methods: {
    // 查询渠道
    async queryChannel(queryString, cb) {
      // 移除app_id参数的限制，获取所有渠道
      try {
        const res = await getChannelList()
        if (res.err_code === 0) {
          this.channelList = res.rows || []
          // 改进模糊搜索逻辑，支持更灵活的匹配
          const results = queryString
            ? this.channelList.filter(item => {
                // 支持渠道名称和别名的模糊搜索
                const nameMatch = item.name && item.name.toLowerCase().includes(queryString.toLowerCase())
                const aliasMatch = item.alias && item.alias.toLowerCase().includes(queryString.toLowerCase())
                return nameMatch || aliasMatch
              })
            : this.channelList
          cb(results)
        } else {
          cb([])
        }
      } catch (error) {
        console.error('获取渠道列表失败:', error)
        cb([])
      }
    },

    // 选择渠道
    handleSelectChannel(item) {
      this.selectedChannelId = item.id
      // 同时设置表单字段以通过验证
      this.form.channel = item.realname + (item.alias ? '(' + item.alias + ')' : '')
      // 手动触发验证
      this.$refs.channelForm.validateField('channel')
    },

    // 关闭对话框
    handleClose() {
      this.$emit('update:visible', false)
      this.$emit('close')
    },

    // 提交表单
    handleSubmit() {
      this.$refs.channelForm.validate(async (valid) => {
        if (valid) {
          if (!this.selectedChannelId) {
            this.$message.warning('请选择渠道')
            return
          }
          
          this.submitLoading = true
          try {
            const params = {
              user_id: this.userId,
              channel_id: this.selectedChannelId
            }
            
            const res = await updateZcbUser(params)
            if (res.err_code === 0) {
              this.$message.success('保存成功')
              this.$emit('success')
              this.handleClose()
            } else {
              this.$message.error(res.err_msg || '保存失败')
            }
          } catch (error) {
            console.error('保存失败:', error)
            this.$message.error('保存失败')
          } finally {
            this.submitLoading = false
          }
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.dialog-footer {
  text-align: center;
}
</style>